import {styled} from "@mui/system";
import {Tab, tabClasses } from '@mui/base/Tab';
import { buttonClasses } from '@mui/base/Button';

const TabBase = styled(Tab)`
            background: linear-gradient(88.65deg, #3E9FDD 0%, #2F749F 98.83%) !important;
            border-radius: 5px;
            width: 155px;
            height: 48px !important;
            border: none !important;
            color: #FFFFFF;
            font-family: Roboto;
            font-weight: 550;
            font-size: 1.1rem;
        
            &:focus {
            color: black;
            outline: 1px solid #3E9FDD;
            }
            
            &.${tabClasses.selected} {
            background: white !important;
            color: black;
            outline: 1px solid #3E9FDD;
            }
            
            &.${buttonClasses.disabled} {
            opacity: 0.5;
            cursor: not-allowed;
            color: black;
            background: grey !important;
            }
            `

export default TabBase;
